import { motion } from "motion/react";

function Footer() {
    return (
      <footer
        className="bg-[#0C1925] border-t border-white/10 px-6 py-6 md:px-10"
        style={{ fontFamily: "'Inter', sans-serif" }}
      >
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-4 md:flex-row">
          <p className="text-center text-sm text-white/40 md:text-left">
            © {new Date().getFullYear()} LMS Technologies. Tous droits réservés.
          </p>

          <div className="flex w-full items-center justify-center gap-5 text-center text-sm lg:w-auto lg:justify-start lg:text-left">
            <a href="/condition" className="text-white/50 transition-colors hover:text-white">
              Conditions d&apos;utilisation
            </a>
            <span className="text-white/20">|</span>
            <a href="/confidentiality" className="text-white/50 transition-colors hover:text-white">
              Politique de confidentialite
            </a>
          </div>

          {/* Réseaux sociaux */}
          <div className="flex items-center gap-6">
          {[
            {
              label: "Instagram",
              href: "https://www.instagram.com/lmstechnologieweb/",
              icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/>
                </svg>
              ),
            },
            {
              label: "Facebook",
              href: "https://www.facebook.com/profile.php?id=61589029875045",
              icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              ),
            },
          ].map(({ label, href, icon }) => (
            <motion.a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className="text-white/40 hover:text-white transition-colors"
              whileHover={{ scale: 1.2, y: -2 }}
              whileTap={{ scale: 0.9 }}
              transition={{ duration: 0.2 }}
            >
              {icon}
            </motion.a>
          ))}
          </div>
        </div>
      </footer>
    );
  }

  export default Footer;